import t from "./_getMapData.js";
var e = t;
function r(a) {
  return e(this, a).get(a);
}
var m = r;
export {
  m as default
};
//# sourceMappingURL=_mapCacheGet.js.map
